import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Signup from "@/pages/OpenAccount";
import ForgotPassword from "@/pages/ForgotPassword";
import Dashboard from "@/pages/Dashboard";
import AccountDetail from "@/pages/AccountDetail";
import CardDetail from "@/pages/CardDetail";
import Transfers from "@/pages/Transfers";
import BillPay from "@/pages/BillPay";
import Invest from "@/pages/Invest";
import Statements from "@/pages/Statements";
import Admin from "@/pages/Admin";

function Protected({ children, admin }) {
  const { user } = useAuth();
  if (user === null) return <div className="p-10 text-slate-500" data-testid="auth-loading">Loading...</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (admin && user.role !== "admin") return <Navigate to="/" replace />;
  return <Layout>{children}</Layout>;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/" element={<Protected><Dashboard /></Protected>} />
          <Route path="/accounts/:id" element={<Protected><AccountDetail /></Protected>} />
          <Route path="/cards/:id" element={<Protected><CardDetail /></Protected>} />
          <Route path="/transfer" element={<Protected><Transfers /></Protected>} />
          <Route path="/billpay" element={<Protected><BillPay /></Protected>} />
          <Route path="/invest" element={<Protected><Invest /></Protected>} />
          <Route path="/statements" element={<Protected><Statements /></Protected>} />
          <Route path="/admin" element={<Protected admin><Admin /></Protected>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster richColors position="top-right" />
    </AuthProvider>
  );
}
